const API_BASE = import.meta.env.VITE_API_URL ?? "https://workin-api.diamante-rita.workers.dev";
const returnTo = encodeURIComponent(window.location.origin);
const GOOGLE_AUTH_URL = import.meta.env.DEV
  ? `/api/auth/google?return_to=${returnTo}`
  : `${API_BASE}/api/auth/google?return_to=${returnTo}`;

function openOAuthPopup() {
  const w = 500;
  const h = 650;
  const left = Math.round(window.screenX + (window.outerWidth - w) / 2);
  const top = Math.round(window.screenY + (window.outerHeight - h) / 2);
  localStorage.setItem("oauth_popup", "1");
  const popup = window.open(GOOGLE_AUTH_URL, "workin_oauth", `popup,width=${w},height=${h},left=${left},top=${top}`);
  if (!popup) {
    // Popup bloccato: rimuovi il flag e fai redirect normale
    localStorage.removeItem("oauth_popup");
    window.location.href = GOOGLE_AUTH_URL;
  }
}

export default function Login() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white px-6 py-10 sm:p-10 rounded-2xl shadow-sm border border-gray-200 flex flex-col items-center gap-6 w-full max-w-sm">
        <div className="flex flex-col items-center gap-2">
          <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center">
            <span className="text-white font-bold text-xl">W</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">WorkIn</h1>
          <p className="text-gray-500 text-sm text-center">Prenota la tua postazione in ufficio</p>
        </div>
        <button
          type="button"
          onClick={openOAuthPopup}
          className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          Accedi con Google
        </button>
      </div>
    </div>
  );
}
